import { useMemo, useState } from "react";
import {
  List,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  DateField,
  BooleanField,
  NumberField,
  BulkDeleteWithConfirmButton,
  useResourceContext,
  useTheme,
  usePermissions,
  FunctionField,
} from "react-admin";
import JournalAddDialog from "../../components/journals/create/JournalAddDialog";
import JournalEditDialog from "../../components/journals/edit/JournalEditDialog";
import journalFilterList from "../../components/journals/filter/journalFilterList";
import TableListActionsWithUpload from "../../components/tableListActions/TableListActionsWithUpload";
import JournalExpandList from "../../components/journals/expand/JournalExpandList";
import EditBtn from "../../components/editBtn/EditBtn";
import ConfirmBtn from "../../components/confirmBtn/ConfirmBtn";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import JournalUploadDialog from "../../components/journals/upload/JournalUploadDialog";
import DeliveryNote from "../../components/print/DeliveryNote";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const JournalList = () => {
  const resource = useResourceContext();
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [openAdd, setOpenAdd] = useState(false);
  const [openUpload, setOpenUpload] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();
  const [theme] = useTheme("light");

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenUpload = () => {
    setOpenUpload(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const list = useMemo(
    () => (
      <List
        title="mine.list_title.journal"
        empty={false}
        actions={
          <TableListActionsWithUpload
            createHandler={handleClickOpenAdd}
            uploadHandler={handleClickOpenUpload}
            exporter={false}
            createPermission="create_journal"
          />
        }
        filters={journalFilterList(permissions)}
        queryOptions={{ meta: { sort: ["journals.code DESC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
      >
        <DatagridConfigurable
          // FIXME: semua datagrid perlu pake custom bulk action ini
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
          expand={<JournalExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.company" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          {/* <FunctionField
            source="salesman.name"
            label="Salesman"
            render={(record) => {
              return record.salesman_id
                ? record.salesman.name + " (" + record.salesman.code + ")"
                : "-";
            }}
          /> */}
          <NumberField source="total" />
          <TextField source="note" label="mine.label.note" />
          <TextField
            source="category.name"
            label="mine.label.category"
            emptyText="-"
          />
          <FunctionField
            source="salesman.name"
            label="Salesman"
            render={(record) => `${record.salesman.name} - ${record.salesman.code}`}
          />
          <BooleanField
            source="approved"
            label="mine.label.approved"
            textAlign="center"
          />
          <WrapperField label="mine.label.actions" textAlign="center">
            <WithRecord
              render={(record) => {
                return record.approved ? (
                  <>
                    <DeliveryNote
                      record={record}
                      tabTitle="Print Bukti Pengeluaran Kas/Bank"
                    />
                    {permissions && permissions.administrator ? (
                      <ConfirmBtn
                        title="mine.message.unapprove"
                        content="mine.message.unapprove_content"
                        label="mine.label.unapprove"
                        resource={resource + "/unapprove"}
                        startIcon={<CloseIcon />}
                        color="error"
                        sx={{ ml: 1 }}
                      />
                    ) : null}
                  </>
                ) : (
                  <>
                    <EditBtn
                      editHandler={handleClickOpenEdit(record.id)}
                      sx={{ mr: 1 }}
                    />
                    <ConfirmBtn
                      title="mine.message.approve"
                      content="mine.message.approve_content"
                      label="Approve"
                      resource={resource + "/approve"}
                      startIcon={<DoneIcon />}
                    />
                  </>
                );
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return (
    <>
      {list}
      <JournalAddDialog open={openAdd} setOpen={setOpenAdd} />
      <JournalEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
      {openUpload ? (
        <JournalUploadDialog open={openUpload} setOpen={setOpenUpload} />
      ) : null}
    </>
  );
};

export default JournalList;
